/**
 * SAM-1293: a pass created with a payment link is born «Proccesing» (the backend's spelling; ids differ per tenant, so it
 * is told by name) and gives no access until the guest pays. Such a pass shows no QR, Share or door PIN.
 */
const AWAITING_PAYMENT_NAMES = ['proccesing', 'processing'];

export const isAwaitingPayment = (statusName?: string | null): boolean =>
  AWAITING_PAYMENT_NAMES.includes((statusName ?? '').trim().toLowerCase());

/** The create answer may carry the id and no name: id 8 is Processing, the id ConfirmationView already shows as such. */
const PROCESSING_STATUS_ID = 8;

export const isAwaitingPaymentPass = (pass?: { status_name?: string | null; business_access_status_id?: number | string | null } | null): boolean =>
  pass?.status_name ? isAwaitingPayment(pass.status_name) : Number(pass?.business_access_status_id) === PROCESSING_STATUS_ID;

/**
 * The only status action of a pass waiting for its payment link is Cancel (the server accepts only Cancel on it:
 * `payment_not_active` for anything that would give access). Before SAM-1293 the list had none, so an unpaid
 * pass could not be cancelled from the admin.
 */
export const awaitingPaymentActions = (statusName?: string | null): string[] => (isAwaitingPayment(statusName) ? ['Cancel'] : []);
